
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.665 21.316c0 10.143-10.394 22.735-17.748 33.601-1.606 2.372-5.145 2.534-6.859.24C8.888 42.88.665 31.733.665 21.315.665 9.543 10.067 0 21.665 0s21 9.543 21 21.316z","fill":"#246AEA"}})])
          )
        }
      }
    